import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import _ from 'lodash';
import { Route, Redirect, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import withWidth from '@material-ui/core/withWidth';
import { sessionService } from 'redux-react-session';
import ErrorBoundary from 'components/ErrorBoundary';
import apiFetch from 'utils/apiFetch';
import SplashScreen from 'components/SplashScreen';
import { GLOBAL_ROOM } from 'modules/socket/constants';
import { joinInNodeRoom } from 'modules/socket/actions';
import {
  ROUTE_LOGIN, ROUTE_LOGOUT, ROUTE_INITIATIVES,
  BASEROUTE, ROUTE_SIGNUP, ROUTE_FORGET_PASSWORD,
} from 'constants/urls';
import Layout from 'components/Layout';
import history from '../../../store/history';
import Loading from '../../../components/Loading';

import { routes } from '../../index';

const URLS_NO_REDIRECT = [BASEROUTE, ROUTE_LOGOUT, ROUTE_SIGNUP, ROUTE_LOGIN, ROUTE_FORGET_PASSWORD];

class App extends Component {
  componentDidMount() {
    const { fetchInstance } = this.props;

    const domain = (process.env.NODE_ENV === 'development') ? 'rise-develop.webintra.net' : window.location.host;
    // const domain = (process.env.NODE_ENV === 'development') ? 'app.callforimpact.com' : window.location.host;
    // const domain = (process.env.NODE_ENV === 'development') ? 'collaborative-intelligence.webintra.net' : window.location.host;

    // const domain = 'app.callforimpact.com';
    fetchInstance(domain);

    const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
    const eventer = window[eventMethod];
    const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

    // Listen to message from child window
    eventer(messageEvent, (e) => {
      switch (e.data) {
        case 'leave_meeting':
          history.push(ROUTE_INITIATIVES);
          break;
        default:
          break;
      }
    }, false);

    
  }

  componentDidUpdate(prevProps) {
    const { isAuthenticated, app, loading } = this.props;

    if (prevProps.loading < loading) {
      setTimeout(() => {
        this.handleCheckLoading();
      }, 10000);
    }

    if (prevProps.app.id !== app.id) {
      this.getUserSession();
    }

    if (!prevProps.isAuthenticated && isAuthenticated) {
      joinInNodeRoom(GLOBAL_ROOM, app.id);
    }
  }

  componentWillUnmount() {
    clearInterval(this.checkLoading);
  }

  loadPhysicsLibraries = () => {
    const libraries = ['/js/createjs_1.1_min.js', '/js/zim10.js', '/js/Box2dWeb-2.1.a.3.min.js', '/js/physics.js'];

    _.forEach(libraries, (library) => {
      const src = `${window.location.origin}${library}`;
      const scriptPhysic = document.createElement('script');
      scriptPhysic.src = src;
      document.head.appendChild(scriptPhysic);
    });
  }

  handleCheckLoading = () => {
    const { lastLoading, resetLoading } = this.props;
    if ((new Date().getTime() - lastLoading) >= 10000) {
      resetLoading();
    }
  }

  getUserSession = () => {
    const { setIsAuthenticated, app } = this.props;

    apiFetch('GET', { endPoint: 'users/session' })
      .then((response) => {
        const user = Object.assign({}, response);
        user.instance = app.id;
        sessionService.saveSession({ token: user.user_code })
          .then(() => {
            sessionService.saveUser(user)
              .then(() => {
                setIsAuthenticated(true);
                ReactGA.set({ userId: user.id });
              });
          });
      })
      .catch(() => {
        if (!app.isAuthenticated && !URLS_NO_REDIRECT.includes(window.location.pathname)) {
          window.urlToRedirect = window.location.href;
        }

        let path = window.location.pathname;
        if (path.indexOf('signup') >= 0) {
          path = '/signup';
        }
        const route = _.find(routes, { path });
        if (!route || !route.ignoreSession) {
          history.push(ROUTE_LOGOUT);
        }
      });
  }


  render() {
    const {
      sessionChecked,
      loading,
      app,
      actualContext,
      isAuthenticated,
    } = this.props;

    if (!app.code) {
      return false;
    }

    let splashScreenType = '';
    if (window.location.pathname.indexOf('zoom-meeting') >= 0) {
      splashScreenType = 'zoom-meeting';
    }

    return (
      <ErrorBoundary>
        <Loading hide={!loading} actualContext={actualContext} app={app} />
        <ConnectedRouter history={history}>
          <Layout show={isAuthenticated}>
            <Switch>
              {sessionChecked && routes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  exact={route.exact}
                  render={() => ((route.ignoreSession || app.isAuthenticated) ? (
                    <section>
                      <route.component route={history} />
                    </section>
                  ) : (
                    <Redirect to={{
                      pathname: ROUTE_LOGIN,
                      state: { from: window.location.pathname },
                    }}
                    />
                  ))}
                />
              ))}
            </Switch>
          </Layout>
        </ConnectedRouter>
        <SplashScreen type={splashScreenType} />
      </ErrorBoundary>
    );
  }
}

App.propTypes = {
  sessionChecked: PropTypes.bool.isRequired,
  loading: PropTypes.number.isRequired,
  fetchInstance: PropTypes.func.isRequired,
  app: PropTypes.object.isRequired,
  setIsAuthenticated: PropTypes.func.isRequired,
  actualContext: PropTypes.object,
  isAuthenticated: PropTypes.bool.isRequired,
  lastLoading: PropTypes.number,
  resetLoading: PropTypes.func.isRequired,
};

App.defaultProps = {
  actualContext: null,
  lastLoading: 0,
};

export default withWidth()(App);



// WEBPACK FOOTER //
// ./src/routes/App/components/index.jsx